import './definition-list.css'

export function DefinitionList({
  items,
}: {
  items: Array<{ label: string; details: string[] }>
}) {
  return (
    <dl className="definition-list">
      {items.map((item) => (
        <div className="definition-list__item" key={item.label}>
          <dt>{item.label}</dt>
          <dd>
            {item.details.map((detail) => (
              <span key={detail}>{detail}</span>
            ))}
          </dd>
        </div>
      ))}
    </dl>
  )
}
